import { List, useTranslation, useTranslationRoute, useTranslations, useUserProfilePicture } from "@bsm/component";
import StudentListQuery from "../query/StudentListQuery";
import { StudentListItem } from "../components/StudentListItem";
import { Link, useNavigate } from "react-router-dom";
import { Table } from "@bsm/component";
import { TUserStudent } from "@bsm/graphql";

export function StudentListContainer() {
    const tr = useTranslationRoute();
    const [TITLE, ADD, COL_ID, COL_FIRSTNAME, COL_LASTNAME, COL_CLASS, COL_ACTION, ACTION_VIEW] = useTranslations(i18nKeys)
    const profilePictureUrl = useUserProfilePicture();
    const navigate = useNavigate();
    const t = useTranslation()

    return (
        <div className="main-content">
                <h2 className="text-3xl self-start">{TITLE}</h2>
                
                <Table
                    id={STUDENTS_LIST_ID}
                    BoxProps={{
                        className: 'box-transparent shadow-none'
                    }}
                    selection={false}
                    search={true}
                    pagination={true}
                    GQLRequest={StudentListQuery}
                    defaultFilter={{
                        page: 0,
                        pageSize: 10,
                        sort: [{ sort: "DESC", value: "createdAt" }],
                    }}
                    columns={[
                        {
                            key: 'id',
                            label: COL_ID,
                            value: (row: TUserStudent) => (
                                <span className="font-bold">{row?.id || '-'}</span>
                            )
                        },
                        {
                            key: 'prenom',
                            label: COL_FIRSTNAME,
                            value: (row: TUserStudent) => (
                                <div className="flex items-center gap-8">
                                    <img
                                        src={profilePictureUrl(row?.user?.id)}
                                        alt={row?.user?.fullName}
                                        className="w-8 h-8 rounded-full object-cover"
                                    />
                                    <span>{row?.user?.firstName || '-'}</span>
                                </div>
                            ),
                            className: 'min-w-[150px]'
                        },
                        {
                            key: 'nom',
                            label: COL_LASTNAME,
                            value: (row: TUserStudent) => row?.user?.lastName || '-',
                            className: 'min-w-[150px]'
                        },
                        {
                            key: 'class',
                            label: COL_CLASS,
                            className: 'max-w-[200px] w-[200px]',
                            value: (row: TUserStudent) => {
                                const classValue = row?.scholarities?.[0]?.scholarityClass?.class?.value ? t(`BSM.Generic.YearGroup.${row?.scholarities?.[0]?.scholarityClass?.class?.value}`) : '-'
                                return classValue
                            }
                        },
                        {
                            key: 'action',
                            label: COL_ACTION,
                            value: (row: TUserStudent) => (
                                <div className="flex gap-8 justify-center items-center">
                                    <button
                                        className="text-[rgb(112,28,16)] hover:text-[rgb(80,20,12)]"
                                        onClick={() => navigate(tr(`admin/students/${row?.id}`))}
                                        title={ACTION_VIEW}
                                    >
                                        <i className="fas fa-eye" />
                                    </button>
                                    {(row.isEditable as unknown as boolean) && (
                                        <button className="text-[rgb(112,28,16)] hover:text-[rgb(80,20,12)]">
                                            <i className="fas fa-pen" />
                                        </button>
                                    )}
                                    <button className="text-[rgb(112,28,16)] hover:text-[rgb(80,20,12)]">
                                        <i className="fas fa-trash-can" />
                                    </button>
                                </div>
                            )
                        }
                    ]}
                />
        </div>
    );
}

const i18nKeys = [
    "BSM.Students.List.Page.Title",
    "std_add",
    "BSM.Students.List.Column.Id",
    "BSM.Students.List.Column.FirstName",
    "BSM.Students.List.Column.LastName",
    "BSM.Students.List.Column.Class",
    "BSM.Students.List.Column.Action",
    "BSM.Students.List.Action.View",
];

const STUDENTS_LIST_ID = "students-list";
